import { Flex } from "~/components/Flex";
import { useSecurityPipelineGithubAutomate } from "./hooks/useSecurityPipelineGithubAutomate";
import { SecurityPipelineGithubAutomateRegression } from "./SecurityPipelineGithubRegression";
import { SecurityPipelineGithubSchedule } from "./SecurityPipelineGithubSchedule";
import { FormProvider } from "react-hook-form";

export const SecurityPipelineGithubPageTabAutomate = () => {
  const {
    isLoading,
    isIntegrationLoading,
    isRunNowLoading,
    handleUpdateAutoCreateWorkflows,
    cadenceOptions,
    daysOfWeekOptions,
    daysOfMonthOptions,
    formMethods,
    onSubmit,
    hasScheduledWorkflows,
    isDisableUpdateButton,
    isCadenceSet,
    firstScheduledWorkflow,
    handleTriggerSecurityPipelineScheduledWorkflows,
  } = useSecurityPipelineGithubAutomate();

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <Flex flexDirection="column" gap={4} /*sx={{ maxWidth: "800px" }}*/>
          <SecurityPipelineGithubSchedule
            cadenceOptions={cadenceOptions}
            daysOfWeekOptions={daysOfWeekOptions}
            daysOfMonthOptions={daysOfMonthOptions}
            hasScheduledWorkflows={hasScheduledWorkflows}
            isCadenceSet={isCadenceSet}
            isLoading={isLoading}
            isDisableUpdateButton={isDisableUpdateButton}
            nextRunAt={firstScheduledWorkflow?.nextRunAt ?? ""}
            onRunNow={handleTriggerSecurityPipelineScheduledWorkflows}
            isRunNowLoading={isRunNowLoading}
          />
          <SecurityPipelineGithubAutomateRegression
            onAutoCreateWorkflowsChange={handleUpdateAutoCreateWorkflows}
            isLoading={isIntegrationLoading}
          />
        </Flex>
      </form>
    </FormProvider>
  );
};
